import request from './request'
export const service = window.globalUrl.service

/*****************用户*******************/

//登录
export const api_login = (data) => {
  return request({
    url: `${service}/user/login`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}

/*****************新闻*******************/

//获取前台新闻列表
export const api_getClientNewsList = (data) => {
  return request({
    url: `${service}/news/getClientNewsList`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}

//获取前台新闻信息（id）
export const api_getClientNewsInfo = (data) => {
  return request({
    url: `${service}/news/getClientNewsInfo`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}

/*****************产品*******************/

//获取前台产品列表
export const api_getClientProductList = (data) => {
  return request({
    url: `${service}/product/getClientProductList`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}

//获取前台产品信息
export const api_getClientProductInfo = (data) => {
  return request({
    url: `${service}/product/getClientProductInfo`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}

/*****************荣誉*******************/

//获取前台荣誉列表
export const api_getClientHonorList = (data) => {
  return request({
    url: `${service}/honor/getClientHonorList`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}

/*****************伙伴*******************/

//获取前台伙伴列表
export const api_getClientPartnerList = (data) => {
  return request({
    url: `${service}/partner/getClientPartnerList`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}

/*****************咨询*******************/

//提交咨询
export const api_submitConsult = (data) => {
  return request({
    url: `${service}/consult/submitConsult`,
    method: 'POST',
    data,
  }, {
    ERROR_ACTION: 'message',
    TOKEN_REQUIRED:false,
  })
}